<template>
    <v-layout row>
        <v-flex xs12 sm12>
            <v-card class="elavation-1 transparent">
                <v-toolbar class="transparent" flat height="37">
                    <v-btn dark icon title="Back to cut off list" @click="$router.go(-1)">
                        <v-icon>arrow_back</v-icon>
                    </v-btn>
                    <v-spacer></v-spacer>
                    <help-link appId="settings" pageId="face-ai" color="white"></help-link>
                    <v-chip v-show="!loading" label :class="status.color" dark>
                        <span >{{ status.status }}</span>
                    </v-chip>
                </v-toolbar>
            </v-card>
            <v-layout row wrap> 
                <v-flex xs12>
                    <v-card class="elavation-1 transparent">
                        <v-toolbar flat height="40">
                            <v-chip>
                                <v-avatar>
                                    <v-img ref="avatar" :src="awsS3Helper.getAvatarUrl(employee_detail.userId)"></v-img>
                                </v-avatar>
                                {{employee_detail.firstName}} {{employee_detail.lastName}} 
                            </v-chip>
                            <v-spacer></v-spacer>
                            <v-btn v-if="hasEditRights&&!isMaxPhotoCount&&!loading" small class="primary" title="Add photo" @click="showAddPhoto">
                                <v-icon>add</v-icon>&nbsp;Add Photo&nbsp;
                            </v-btn>
                        </v-toolbar>
                        <v-data-table
                            :headers="headers"
                            :items="user_descriptors"
                            :loading="loading"  
                        >
                            <template v-slot:items="props">
                                <tr>
                                    <td>
                                        <v-img :src="commonfn.getFaceAIPhoto(props.item.photoFileName)" width="30"></v-img>
                                    </td>
                                    <td>{{ props.item.createdOn | moment('MMM DD, YYYY') }}</td>
                                    <td>Verified</td>
                                    <td>
                                        <v-chip style="margin:-5px 0px 0px -5px;">
                                            <v-avatar>
                                                <v-img ref="avatar" :src="awsS3Helper.getAvatarUrl(props.item.createdBy.userId)"></v-img>
                                            </v-avatar>
                                            {{props.item.createdBy.firstName}} {{props.item.createdBy.lastName}} 
                                        </v-chip>
                                    </td>
                                    <td>
                                        <v-btn v-if="hasEditRights" icon small title="Delete" @click="showDelete(props.item)">
                                            <v-icon small>delete</v-icon>
                                        </v-btn>
                                    </td>
                                </tr>
                            </template>
                        </v-data-table>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-flex>

        <v-dialog v-model="dialogUploadPhoto" persistent fullscreen hide-overlay transition="dialog-bottom-transition">   
            <upload-photo :pageKey="pageKeys.faceai_settings" @send="uploadHandler" :dialogUploadPhoto.sync="dialogUploadPhoto"></upload-photo>
        </v-dialog>

        <v-dialog v-model="dialogModelTraining" width="400" persistent>
            <v-card class="elavation-1" style="border-radius:4px;"> 
                <v-toolbar flat height="45px">
                    <span class="font-weight-bold ">Loading</span>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-card-text class="text-xs-center">
                    <p class="msg-text">{{ processingText }}</p>
                </v-card-text>
            </v-card>
        </v-dialog>

        <v-dialog v-model="dialogDelete" width="500">
            <v-card class="elavation-1" style="border-radius:4px;"> 
                <v-toolbar flat height="45px">
                    <span class="font-weight-bold ">Confirm Delete</span>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-card-text class="text-xs-center">
                    <p>Delete selected photo?</p>
                    <p>Note: you will not be able to undo this operation.</p>
                </v-card-text>
                 <v-divider></v-divider>
                 <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn title="Delete" class="red" dark @click="deletePhoto" :loading="loading_delete">Delete</v-btn>
                    <v-btn title="Cancel" @click="dialogDelete=false">Cancel</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-layout> 
</template>

<script>

import * as faceapi from 'face-api.js'
import commonfn from '@/common/functions'
import faceAIApi from '@/api/faceai'
import employeesApi from '@/api/employees'
import pageKeys from '@/common/pagekeys'
import awsS3Helper from '@/helpers/aws-s3'

export default {     
    name: 'FaceRecognitionActivition',
    metaInfo: {
        title: 'Face Recognition Activition',
        meta: [
            { charset: 'utf-8' },
            { name: 'description', content: 'Face Recognition Activition' },
            { name: 'viewport', content: 'width=device-width, initial-scale=1' }
            ]
    },
    components: {
        'help-link': () => import('@/components/Common/HelpLink'),
        'upload-photo': () => import('@/components/FaceRecognition/UploadPhoto')
    },   
    data () {
        return {
            error: false,
            errorMessage: '',
            loading: false,
            loading_delete: false,
            dialogUploadPhoto: false,
            dialogModelTraining: false,
            dialogDelete: false,
            headers: [
                {text: 'Photo',align: 'left',value: '', width:'20%', sortable:false},
                {text: 'Uploaded On',align: 'left',value: '', width:'20%',sortable:false},
                {text: 'Status',align: 'left',value: '', width:'20%',sortable:false},
                {text: 'Created By',align: 'left',value: '', width:'20%',sortable:false},
                {text: '',align: 'left',value: '', width:'10%',sortable:false}
            ],
            base64Image: null,
            photoFileName: null,
            descriptor: null,
            selectedUserFaceDescriptorId: null,
            user_descriptors: [],
            employee_detail: null,
            processingText: ''
        }
    },
    methods: {
        showDelete(data) {
            this.selectedUserFaceDescriptorId = data.userFaceDescriptorId
            this.dialogDelete = true
        },
        showAddPhoto() {
            this.dialogUploadPhoto = true
        },
        async uploadHandler(data) {
            this.dialogModelTraining = true

            this.base64Image = data.base64Image
            this.photoFileName = data.fileName

            //load models
            this.processingText = 'Loading Models'
            await this.loadModels()

            //train model
            this.processingText = 'Training Models'
            await this.trainModel()

            //save descriptors to db
            this.processingText = 'Saving Descriptors'
            await this.saveDescriptor()

            //clear memory
             this.processingText = 'Finalizing'
            await this.clearMemory()
            
            //display in grid
            await this.getUserDescriptors()

            this.dialogModelTraining = false
        },        
        async loadModels() {
            await faceapi.nets.tinyFaceDetector.loadFromUri('/face-ai/models')
            await faceapi.nets.faceLandmark68Net.loadFromUri('/face-ai/models')
            await faceapi.nets.faceRecognitionNet.loadFromUri('/face-ai/models')
        },
        async trainModel() {
            const label = `${this.$store.state.firstName}_${this.$store.state.lastName}`
            const img = new Image()
            img.src = this.base64Image
            await new Promise((resolve) => (img.onload = resolve))

            const detections = await faceapi
                .detectSingleFace(img, new faceapi.TinyFaceDetectorOptions())
                .withFaceLandmarks()
                .withFaceDescriptor()

            if (detections) {
                this.descriptor = new faceapi.LabeledFaceDescriptors(label, [detections.descriptor])
            }else{
                this.error = true
                this.errorMessage = "Error when processing your photo. Please contact support@sweldonow.ph"
            }
        },
        async saveDescriptor() {
            try{
                const data = {
                    photoFileName: this.photoFileName,
                    descriptors: JSON.stringify(this.descriptor.descriptors)
                }
                await faceAIApi.saveFaceDescriptorsByUser(data, this.selectedUserId)
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        arrayStringifyReplacer(key, value) {
            if (Array.isArray(value)) {
                return JSON.stringify(value) // Keep array format as string
            }
            return value
        },
        async getEmployee() {
            try{
                this.loading = true
                const response = await employeesApi.get(this.selectedUserId)
                if (response && response.status == 200) {
                    this.employee_detail = response.data.basicInfo
                }
                this.loading = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        async getUserDescriptors() {
            try{
                this.loading = true
                const response = await faceAIApi.getFaceDescriptorsByUser(this.selectedUserId)
                if (response && response.status == 200) {
                    this.user_descriptors = response.data.items
                }
                this.loading = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        async deletePhoto() {
            try{
                this.loading_delete = true
                const response = await faceAIApi.deleteFaceDescriptorByUser(this.selectedUserFaceDescriptorId, this.selectedUserId)
                if (response && response.status == 200) {
                    this.dialogDelete = false
                    this.getUserDescriptors()
                }
                this.loading_delete = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        async clearMemory() {
            faceapi.nets.tinyFaceDetector.dispose()
            faceapi.nets.faceLandmark68Net.dispose()
            faceapi.nets.faceRecognitionNet.dispose()

            this.base64Image = null
            this.photoFileName = null
            this.descriptor = null
        }
    },
    async created() {
        this.pageKeys = pageKeys
        this.commonfn = commonfn
        this.awsS3Helper = awsS3Helper
        
        //update header titles
        this.$root.$emit('setHeaderTitles', {
            display: true,
            headerTitle: 'Face AI Activation Details',
            headerPageTitle: ''
        })

        await this.getEmployee()
        await this.getUserDescriptors()
    },
    computed: {
        selectedUserId() {
            return this.$route.params.userId
        },
        hasEditRights() {
            return commonfn.hasEditRights(this.$router.currentRoute.path)
        },
        isMaxPhotoCount() {
            return this.user_descriptors.length == 2
        },
        status() {
            if (this.user_descriptors.length) {
                if (this.user_descriptors.length == 2) {
                    return {
                        status: 'Active',
                        color: 'green'
                    }
                } else {
                    return {
                        status: 'In Complete',
                        color: 'orange'
                    }
                }
            }else{
                return {
                        status: 'Inactive',
                        color: 'orange'
                    }
            }
        }
    }
}
</script>